<div class="video">
    <iframe :width="width"
            :height="height"
            :src="urlVideo"
            :title="title"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen>

    </iframe>
</div>